import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { FormFieldEvent } from '@models/index';

@Component({
  selector: 'app-text-area',
  standalone: true,
  imports: [
    MatInputModule,
    MatFormFieldModule,
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss',
})
export class TextAreaComponent implements OnInit {
  @Input() name = '';
  @Input() label = '';
  @Input() value = '';
  @Input() customErrorMessage = '';
  @Input() isRequired = false;
  @Output() inputEvent = new EventEmitter<FormFieldEvent>();
  public textInputField = new FormControl(this.value);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public handleInputEvent(inputEvent: any): void {

    this.value = (inputEvent.target as HTMLInputElement).value;
    this.inputEvent.emit({
      name: this.name,
      value: this.value,
    });
  }

  ngOnInit(): void {
    const validators: ValidatorFn[] = [];

    if (this.isRequired) {
      validators.push(Validators.required)
    }

    this.textInputField = new FormControl(this.value, validators);
    this.inputEvent.emit({
      name: this.name,
      value: this.value
    });
  }
}
